import { ChangeDetectorRef, Component } from '@angular/core';
import { CmsBannerComponent, CmsService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserInfoService } from '../../spartacus/services/user-info.service';

@Component({
    selector: 'app-order-summary',
    templateUrl: './order-summary.component.html',
    styleUrls: ['./order-summary.component.scss'],
    standalone: false
})
export class OrderSummaryComponent {
  constructor(private cmsService: CmsService,public component: CmsComponentData<CmsBannerComponent>,private cdr:ChangeDetectorRef,
    public userInfoService:UserInfoService) {
  }
  bannerNode: Observable<any> = this.component.data$;
  preSeasonMsg:any
  inseason:string=''
  //orderData:Observable<any> = this.userInfoService.getOrdersDashboard();
  //seasonData :Observable<any> | undefined
 // seasonData :Observable<any> =  this.userInfoService.getseasonDropdown("2024-2025");
  ngOnInit(){
    const body=<HTMLElement>document.querySelector("body");
    body.classList.add("USordersummary");
    this.cmsService.getComponentData('SeqirusOrderSummaryBannerComponent').subscribe(data => {
       this.preSeasonMsg = data
    })
    this.userInfoService.getorderseaosn().subscribe(value=>{
      this.inseason=value;
      this.cdr.detectChanges()
          })
  }
}
